import type {
  CourseSection,
  SurveyQuestion,
  SurveySection,
} from '../types/survey'

export const skillOptions = [
  'Time Value of Money in Financial Decisions',
  'Coaching for Performance',
  'Giving and Receiving Feedback',
  'Managing Difficult Conversations',
  'Strategic Decision Making',
]

export const surveySections: SurveySection[] = [
  {
    id: 'skill-module-experience',
    title: 'Skill Module Experience',
    description:
      'Please let us know your overall experience with your Skill Module.',
    questions: [
      {
        id: 'skill',
        type: 'select',
        prompt: 'Please select the skill you completed from the dropdown below',
        required: true,
        options: skillOptions,
      },
      {
        id: 'role',
        type: 'choice',
        prompt: 'Are you a Mentor or Mentee?',
        required: true,
        options: ['Mentor', 'Mentee', 'Neither / Rather not answer'],
      },
      {
        id: 'experienceRating',
        type: 'scale',
        prompt: 'Please rate your overall experience below:',
        required: true,
        scale: {
          min: 1,
          max: 5,
          minLabel: 'Worst',
          maxLabel: 'Best',
        },
      },
      {
        id: 'satisfied',
        type: 'choice',
        prompt: 'Were you satisfied with this skill module?',
        required: true,
        options: ['Yes', 'No'],
      },
      {
        id: 'satisfactionReason',
        type: 'longText',
        prompt: 'Please tell us why you gave that response.',
        required: false,
        placeholder: 'Share what worked well, or what fell short.',
      },
    ],
  },
  {
    id: 'workplace-transfer',
    title: 'Workplace Transfer',
    description:
      'In this section you will explore how this learning module teaches you how to transfer this skill into your work.',
    questions: [
      {
        id: 'understanding',
        type: 'longText',
        prompt:
          'How has this learning module changed your understanding of this behavioral competency, and how is it relevant to your current role?',
        required: true,
        placeholder: 'Describe what shifted for you.',
      },
      {
        id: 'situation',
        type: 'longText',
        prompt:
          'Can you think of a specific situation at work where this competency would be valuable? Describe the situation and how would you approach it differently now.',
        required: true,
        placeholder: 'Describe the situation and your new approach.',
      },
      {
        id: 'takeaway',
        type: 'longText',
        prompt:
          'What is one key takeaway from this module that you can apply immediately in your daily tasks?',
        required: true,
        placeholder: 'One specific thing you will do differently.',
      },
      {
        id: 'challenges',
        type: 'longText',
        prompt:
          "Are there any challenges preventing you from applying what you've learned within this module? If so, what are they?",
        required: false,
        placeholder: 'Optional — tell us what stands in the way.',
      },
    ],
  },
  {
    id: 'other-questions',
    title: 'Other Questions',
    questions: [
      {
        id: 'priorFeedback',
        type: 'longText',
        prompt:
          'Prior to taking this module, had you received any feedback from supervisors or peers related to your approach to or understanding of this topic?',
        required: true,
        placeholder: 'Summarize any feedback you had already received.',
      },
      {
        id: 'habits',
        type: 'longText',
        prompt:
          'What specific habits or behaviors do you want to improve based on this learning?',
        required: true,
        placeholder: 'Name the habits you are committing to.',
      },
    ],
  },
]

export const surveyQuestions: SurveyQuestion[] = surveySections.flatMap(
  (section) => section.questions,
)

export const courseOutline: CourseSection[] = [
  {
    id: 'introduction',
    title: 'Introduction',
  },
  {
    id: 'time-value',
    title: 'Utilizing the Time Value of Money in Financial Decisions',
  },
  {
    id: 'conclusion',
    title: 'Conclusion',
  },
  {
    id: 'wrap-up',
    title: 'Wrap Up',
    items: [
      {
        id: 'wrap-up-lesson',
        title: 'Wrap Up',
        status: 'incomplete',
      },
      {
        id: 'survey',
        title: 'Survey',
        status: 'complete',
      },
    ],
  },
]
